import React from 'react';
import $ from 'jquery';
import { isMobile } from '../../constants/Constants';

class Dropdown extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      activePopUpIndex: -1,
    };
  }

  exportImportSettings = btnIndex => {
    const dropdown = $('#dropdown');
    dropdown.removeClass('dropdown-visible');

    $(document).trigger('openPopUp');

    const popUp = $('#export-import-pop-up');
    const popUpClass = ['export', 'import'][btnIndex] + 'PopUp';

    popUp.addClass(popUpClass);
    this.props.updateImportPopupOpen(true);
    this.setState({ activePopUpIndex: btnIndex });

    $(document).on(isMobile ? 'touchend' : 'mousedown', this.closePopUp);
  };

  closePopUp = event => {
    const popUp = $('#export-import-pop-up');
    const popUpClass = ['export', 'import'][this.state.activePopUpIndex] + 'PopUp';

    if (!popUp.find(event.target).length && popUp[0] !== event.target) {
      $(document).off(isMobile ? 'touchend' : 'mousedown', this.closePopUp);
      popUp.removeClass(popUpClass);

      this.props.updateImportPopupOpen(false);
      this.setState({ activePopUpIndex: -1 });
    }
  };

  render() {
    return (
      <div id="dropdown">
        <button
          type="button"
          className="dropdownButton"
          id="export-settings-btn"
          onClick={() => this.exportImportSettings(0)}
        >
          Export Settings
        </button>
        <button
          type="button"
          className="dropdownButton"
          id="import-settings-btn"
          onClick={() => this.exportImportSettings(1)}
        >
          Import Settings
        </button>
      </div>
    );
  }
}

export default Dropdown;
